import { createContext } from '@lit/context';

export interface AddToListLayerState {
  open: boolean;
  backButtonCallback?: (() => void),
  update: (newState: Partial<AddToListLayerState>) => void;
}

export const addToListLayerContext = createContext<AddToListLayerState>('addToListLayerContext');
